import React from 'react';
import MuiCheckbox from '@mui/material/Checkbox';

const Checkbox = (props) => {
  return <MuiCheckbox {...props} />;
};

export default Checkbox;

